// extracted by mini-css-extract-plugin
export default {"item":"Item_item__cqHSd","avatar":"Item_avatar__OitLA","man":"Item_man__mQuEY","position":"Item_position__hsHI1"};